module.exports = __webpack_public_path__ + "static/media/knowsTheField.dbadbb0f.png";